import React, { Component } from 'react'
import PhotoLoader from '../PhotoLoader'
import TagsEditor from '../TagsEditor'
import Switch from 'react-ios-switch'
import { toast } from 'react-toastify'
import './styles/style.css'

const mergeObjects = (oldObj, newObj) => {
    let res = { ...oldObj }
    for (const key in newObj) {
        if (newObj.hasOwnProperty(key)) {
            const val = newObj[key]
            if (val !== '') {
                res[key] = val
            }
        }
    }
    return res
}

class ObjectEditor extends Component {

    constructor(props) {
        super(props)
        this.state = {
            ...props.object
        }
    }

    componentWillReceiveProps = (nextProps) => {
        console.log('after save', nextProps.object, this.state)

        this.setState({
            ...mergeObjects(this.state, nextProps.object)
        })
    }


    render() {
        const notSaved = this.state.id === ''
        return (
            <div className="ObjectEditorWrapper">
                <div className="ObjectPageWrapper">
                    <div className="ObjectTitleWrapper">
                        <span className="fieldLabel">
                            {'Название'}
                        </span>
                        <input type="text" value={this.state.title} placeholder={'Введите название'} className={'ObjectTitleInput'} onChange={(e) => {
                            this.setState({
                                title: e.nativeEvent.target.value
                            })
                        }} />
                    </div>
                    <div className="PageColumnsWrapper">
                        <div className="PageColumn">
                            <div
                                className={`FieldWrapper ${notSaved ? 'Inactive' : ''}`}
                                onClick={notSaved ? () => {
                                    toast.error(`Сначала сохраните объект`, {
                                        position: toast.POSITION.TOP_RIGHT
                                    })
                                } : undefined}
                            >
                                <span className="fieldLabel">
                                    {'Фото'}
                                </span>
                                <PhotoLoader
                                    filesList={this.state.photo}
                                    onLoad={(filesList) => {
                                        this.setState({
                                            photo: filesList
                                        }, () => {
                                            if (this.props.save) {
                                                this.props.save()
                                            }
                                        })
                                    }} />
                            </div>
                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Теги'}
                                </span>
                                <TagsEditor tags={this.state.tags} onChange={(tags) => {
                                    this.setState({
                                        tags: tags
                                    })
                                }} />
                            </div>
                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Адрес'}
                                </span>
                                <input placeholder={'Введите адрес'} type="text" value={this.state.address} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        address: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                        </div>
                        <div className="PageColumn">
                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Статус обекта'}
                                </span>
                                <div className="SwithWrapper">
                                    <span className="SwitchTitle">{'Обьект построен'}</span>
                                    <Switch
                                        onColor={'#16864e'}
                                        checked={this.state.isReady}
                                        onChange={val => {
                                            this.setState({
                                                isReady: val
                                            })
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Застройщик'}
                                </span>
                                <input placeholder={'Введите название застройщика'} type="text" value={this.state.builder} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        builder: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Дата сдачи'}
                                </span>
                                <input placeholder={'Введите дату сдачи'} type="text" value={this.state.date} className="FormInput" onChange={(e) => {
                                    this.setState({
                                        date: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>

                            <div className="FieldWrapper">
                                <span className="fieldLabel">
                                    {'Описание'}
                                </span>
                                <textarea value={this.state.descr} className={'FormInputArea'} onChange={(e) => {
                                    this.setState({
                                        descr: e.nativeEvent.target.value
                                    })
                                }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ObjectEditor


// WEBPACK FOOTER //
// ./src/Components/ObjectEditor/index.js